import React from "react"
import { ReactComponent as CheckIcon } from "images/icons/check-thick.svg"
import { ReactComponent as ClockIcon } from "images/icons/clock.svg"
import { Section, StatusContainer } from "./CustomerOrderTable.styled"
import { Tooltip } from "react-tooltip"
import { ShopperInsightsSearchHitCheckout } from "lib/types/generated/graphql-types"

type Props = {
  checkout: ShopperInsightsSearchHitCheckout
}

const CheckoutStatus = ({ checkout }: Props) => {
  const isConfirmed = checkout.isConfirmed
  const isPending = checkout.isPendingConfirmation
  const tooltipId = `checkout-${checkout.id}`

  const getStatusText = () => {
    if (isConfirmed) return "Order confirmed"
    if (isPending) return "Order pending confirmation"
    return "Checkout incomplete"
  }

  return (
    <Section>
      <Tooltip id={tooltipId}>
        <div>{getStatusText()}</div>
      </Tooltip>
      <StatusContainer $blocked={!isConfirmed} data-tooltip-id={tooltipId}>
        {isConfirmed ? <CheckIcon /> : <ClockIcon />}
      </StatusContainer>
    </Section>
  )
}

export default CheckoutStatus
